import dynamic from 'next/dynamic';
import Link from 'next/link';
import Router from 'next/router';
import { useState } from 'react';
import { IoClose } from 'react-icons/io5';
import { RiErrorWarningLine } from 'react-icons/ri';
import ReactModal from 'react-modal';
import Cookies from 'universal-cookie';

import { createAddressUser } from '../../api/wave/users';
import User from '../../store/user';
import { addToAnalytics } from '../../utils/analytics';
import CUSTOM_STYLES from '../../utils/modalStyle';
import { SecondaryButton } from '../Buttons/Buttons';

import styles from './AddAddress.module.scss';

const customStyles = {
  overlay: {
    ...CUSTOM_STYLES.overlay,
  },
  content: {
    ...CUSTOM_STYLES.content,
    padding: '1rem 1.5rem',
    maxWidth: '100%',
    minWidth: '21.25rem',
  },
};

const AddressView = dynamic(() => import('../GenericModal/AddressView/AddressView'), { ssr: false });

export default function AddAddress({ children }) {
  const [error, setError] = useState(false);

  const cookies = new Cookies();

  async function addAddressRequest(newAddress) {
    setError('');
    addToAnalytics('addAddres', undefined, [['option', 'submit']]);
    const addressToCreate = { address: [{ ...newAddress }] };
    const token = cookies.get('token');
    const response = await createAddressUser(token, addressToCreate);
    if (typeof response === 'string' || response?.error) {
      setError(true);
      return;
    }
    User.addAddress(response?.address);
    Router.push('/', '/');
  }

  return (
    <div className={styles.container}>
      {children}
      <p className={styles.subheader}>Συμπλήρωσε τα στοιχεία της διεύθυνσής σου.</p>
      <AddressView submitForm={addAddressRequest} />
      <ReactModal style={customStyles} isOpen={error}>
        <div className={styles.modalHeader}>
          <button type="button" className={styles.close} onClick={() => setError(false)}>
            <IoClose className={styles.closeSymbol} />
          </button>
        </div>
        <div className={styles.errorContainer}>
          <RiErrorWarningLine className={styles.errorIcon} />
          <p className={styles.errorMessage}>
            Κάτι πήγε στραβά και δεν μπορέσαμε να αποθηκεύσουμε τα στοιχεία της διεύθυνσής σου.
          </p>
          <p className={styles.completeRegister}>
            Η εγγραφή σου έχει ολοκληρωθεί. Συνέχισε τις αγορές σου και αποθήκευσέ την διεύθυνση σου αργότερα.
          </p>
          <Link href="/">
            <a className={styles.link}>
              <SecondaryButton>Επιστροφή στην Αρχική</SecondaryButton>
            </a>
          </Link>
        </div>
      </ReactModal>
    </div>
  );
}
